import "../../assets/css/admin_users_page.css";
import Header from "./includes_admin/Header";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import "../../assets/css/subusers_page.css";
import { FormPrincipalUser } from "./AdminPrincipal/FormPrincipalUser";
import { Button } from "react-bootstrap";

export const AdminPrincipal = () => {
  const history = useHistory();

  const goBack = () => {
    history.push("/admin");
  };

  return (
    <>
        <div className="row mb-4">
          <Header hideBusinessBadge />
        </div>
        <div className="subuser-page">
          <Button size="md" onClick={goBack} className="users_back_btn btn-warning subuser-back-btn">
            <FontAwesomeIcon icon={faArrowLeft} style={{ fontSize: 16, color: "black" }} className="me-3" />
              Volver al inicio
          </Button>
          <FormPrincipalUser />
        </div>
    </>
  );
};
